import React, { createContext, useReducer } from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';

export const ClientContext = createContext();

// Get initial client state
const getInitialClientState = () => {
	// Fallback to stored client ID for development, then default
	const storedClientId = Cookies.get('client-id') || import.meta.env.VITE_DEFAULT_CLIENT_ID || '00000000-0000-0000-0000-000000000001';

	return {
		clientId: storedClientId,
		isDevelopmentMode: import.meta.env.DEV
	};
};

const initialState = getInitialClientState();

function clientReducer(state, action) {
	switch (action.type) {
	case 'set-client':
		// Update client ID and store in cookie (development mode)
		Cookies.set('client-id', action.clientId, {
			secure: import.meta.env.PROD,
			sameSite: 'strict',
			expires: 30 // 30 days
		});
		return {
			...state,
			clientId: action.clientId
		};
	case 'set-client-from-user': {
		// Extract client ID from user object
		const clientId = action.clientId || state.clientId;
		if (action.clientId) {
			Cookies.set('client-id', clientId, {
				secure: import.meta.env.PROD,
				sameSite: 'strict',
				expires: 30
			});
		}
		return {
			...state,
			clientId
		};
	}
	default:
		throw new Error(`Unrecognized action in ClientContext: ${action.type}`);
	}
}

export const ClientProvider = ({ children }) => {
	const [state, dispatch] = useReducer(clientReducer, initialState);

	const setClientId = (clientId) => {
		dispatch({
			type: 'set-client',
			clientId
		});
	};

	const setClientFromUser = (clientId) => {
		dispatch({
			type: 'set-client-from-user',
			clientId
		});
	};

	return (
		<ClientContext.Provider
			value={{
				state,
				actions: {
					setClientId,
					setClientFromUser
				}
			}}
		>
			{children}
		</ClientContext.Provider>
	);
};

ClientProvider.propTypes = {
	children: PropTypes.node.isRequired
};
